import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  visit (event: Event): void {
    event.preventDefault()

    const hrefUrl = new URL(this.element.getAttribute('href') as string, window.location.origin)
    const params = new URLSearchParams(window.location.search)

    params.delete('page')
    params.delete('q[domain_id_in][]')

    for (const [key, value] of hrefUrl.searchParams.entries()) {
      params.set(key, value)
    }

    let newUrl = hrefUrl.pathname
    if (params.toString() !== '') newUrl += `?${params.toString()}`
    if (hrefUrl.hash !== '') newUrl += hrefUrl.hash

    Turbo.visit(newUrl, { frame: 'domains-show' })
    Turbo.navigator.history.replace(new URL(newUrl, window.location.origin))
  }
}
